export const createIconProps = (icon, scaledSize) => ({
  url: icon,
  scaledSize,
});
